import { RefObject, useCallback, useEffect, useState } from 'react';
interface TrackOverflowOptions {
  enabled?: boolean;
  threshold?: number;
}
const DEFAULT_OPTIONS = {
  enabled: true,
  threshold: 0
};
export const useTrackOverflow = <T extends RefObject<HTMLElement | null>,>(ref: T, options?: TrackOverflowOptions) => {
  const {
    enabled,
    threshold
  } = {
    ...DEFAULT_OPTIONS,
    ...options
  };
  const [maxWidth, setMaxWidth] = useState<number | null>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const [initialized, setInitialized] = useState(false);
  const observerCallback = useCallback(() => {
    const el = ref.current;
    if (!el) return;
    setInitialized(true);
    const width = el.clientWidth;
    const scrollWidth = el.scrollWidth;
    if (enabled && width < scrollWidth - threshold) {
      setMaxWidth(scrollWidth);
      setIsOverflowing(true);
      return;
    }
    if (enabled && maxWidth && width >= maxWidth) {
      setMaxWidth(null);
      setIsOverflowing(false);
    }
  }, [enabled, maxWidth, ref, threshold]);
  useEffect(() => {
    const el_0 = ref.current;
    const observer = new ResizeObserver(observerCallback);
    if (el_0) {
      observer.observe(el_0);
    }
    return () => {
      observer.disconnect();
    };
  }, [maxWidth, observerCallback, ref]);
  return {
    isOverflowing,
    initialized
  };
};